import { Input, Component, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { EChartOption } from 'echarts';

@Component({
    selector: 'lazy-echart',
    templateUrl: './lazy-echart.component.html',
    styleUrls: ['./lazy-echart.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LazyEchartComponent {
    @Input() options: EChartOption;
    @Input() passThrough = false;
    @Output() chartClick = new EventEmitter();
}
